function filter (items, keyword)
{
    if (!keyword)
        return items || []

    keyword = keyword.toLowerCase()

    return (items || []).filter (item => item.email.toLowerCase().indexOf(keyword) >= 0)
}

export default 
{
    filter,
}